// removed by extract-text-webpack-plugin
module.exports = {"outerContainer":"styles-module__outerContainer___5pm3z","container":"styles-module__container___26ebz","screenshot":"styles-module__screenshot___2E356","footer":"styles-module__footer___2cqUo"};


//////////////////
// WEBPACK FOOTER
// ./src/core/ui/Modal/HelpModal/styles.module.css
// module id = 398
// module chunks = 0